<template>
  <div>
    <Dialog
      :header="$t('edit-schedule-configuration')"
      :visible.sync="configDialog"
      :style="{ minWidth: '75%', minHeight: '25vh', maxWidth: '95%' }"
      :modal="true"
      :show-header="false"
    >
      <div class="p-mt-3" style="height: 100%; width: 100%; min-height: 50vh">
        <div class="p-my-5" style="height: 5vh">
          <div class="progress-container p-justify-center">
            <ul class="progress-steps">
              <li v-bind:class="{ 'active ': configAdditionalDialog === true }">1</li>
              <li>2</li>
            </ul>
          </div>
        </div>
        <h1 class="title is-2 p-my-3">{{ $t("schedule-settings") }}</h1>
        <div class="p-grid">
          <div class="p-col-6" v-bind:class="{ 'p-col-12': !sconfig.division_id }">
            <div class="p-grid">
              <div class="p-col-12">
                <div class="configBox">
                  <div class="p-grid">
                    <div class="p-col-6">
                      <h2 class="title is-4">{{ $t("choose-division") }}</h2>
                      <Dropdown
                        :options="$store.getters.currentSeason.divisions"
                        optionLabel="name"
                        optionValue="id"
                        :placeholder="$t('choose-division')"
                        class="configDown"
                        v-model="sconfig.division_id"
                      />
                    </div>
                    <div class="p-col-6">
                      <h2 class="title is-4">{{ $t("schedule-type") }}</h2>
                      <Dropdown
                        :options="scheduleTypes"
                        optionLabel="name"
                        optionValue="value"
                        :placeholder="$t('choose-type')"
                        class="configDown"
                        v-model="sconfig.mode"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-col-12" v-if="sconfig.division_id">
                <div class="configBox">
                  <h2 class="title is-4">{{ $t("choose-schedule-style") }}</h2>
                  <Dropdown
                    :options="sconfig.mode === 0 ? gameTypes : practiceTypes"
                    optionLabel="name"
                    optionValue="value"
                    :placeholder="$t('choose-style')"
                    class="configDown"
                    v-model="sconfig.style"
                    @change="
                      () => {
                        if (sconfig.use_weekend_method && sconfig.style === 1) sconfig.count = 2;
                      }
                    "
                  />
                </div>
              </div>
              <div class="p-col-5" v-if="sconfig.division_id">
                <div class="configBox" style="text-align: center" v-tooltip="$t('scheduleTooltip')">
                  <div class="p-field-checkbox title is-4">
                    <Checkbox
                      v-model="sconfig.use_weekend_method"
                      :binary="true"
                      @change="
                        () => {
                          if (sconfig.use_weekend_method && sconfig.style === 1) sconfig.count = 2;
                        }
                      "
                    />&nbsp;
                    <label> {{ $t("use-weekend-method") }}</label>
                  </div>
                  <div v-if="sconfig.use_weekend_method" class="p-field-checkbox">
                    <Checkbox v-model="sconfig.friday_as_weekend" :binary="true" />&nbsp;
                    <label> {{ $t("assume-friday-as-weekend") }} </label>
                  </div>
                  <div v-if="sconfig.use_weekend_method">
                    <small>{{ $t("weekend-method-will-default-to-teams-playing-max-2-games-week") }}</small>
                  </div>
                </div>
              </div>
              <div class="p-col-7" v-if="sconfig.division_id">
                <div class="configBox">
                  <h2 class="title is-4">
                    <span v-if="sconfig.style === 0">
                      {{ $t("number-of-rounds") }}
                    </span>
                    <span v-else-if="sconfig.style === 1">
                      {{ $t("itemstring-plural-per-team-per-week", [itemString.plural]) }}
                    </span>
                    <span v-else-if="sconfig.style === 2">
                      {{ $t("itemstring-plural-per-team", [itemString.plural]) }}
                    </span>
                  </h2>
                  <div v-if="sconfig.use_weekend_method && sconfig.style === 1">
                    <InputNumber :min="2" :max="2" v-model="sconfig.count" class="p-mx-3" />
                  </div>
                  <div v-else>
                    <Button
                      icon="pi pi-minus"
                      class="p-button-rounded p-button-outlined"
                      @click="sconfig.count = Math.min(50, sconfig.count - 1)"
                    />
                    <InputNumber :min="1" v-model="sconfig.count" class="p-mx-3" />
                    <Button
                      icon="pi pi-plus"
                      class="p-button-rounded p-button-outlined"
                      @click="sconfig.count = Math.max(1, sconfig.count + 1)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-col-6" v-if="sconfig.division_id">
            <div class="configBox">
              <h2 class="title is-4">{{ $t("set-schedule-dates") }}</h2>
              <div id="datePicker"></div>
              <AirbnbStyleDatepicker
                :sundayFirst="currentUser.first_day === 0"
                :months-to-show="windowWidth > 1000 ? 2 : 1"
                triggerElementId="datePicker"
                :customized-dates="[{ cssClass: 'old', dates: oldDates }]"
                @date-one-selected="setStartDate"
                @date-two-selected="setEndDate"
                :date-one="sconfig.realStart"
                :date-two="sconfig.realEnd"
                :mode="'range'"
                :inline="true"
                :startOpen="true"
              />
            </div>
          </div>
          <div class="p-col-12" v-if="sconfig.division_id">
            <div class="p-my-3" v-if="sconfig.startDate && sconfig.endDate && division">
              <h2 class="title is-4">{{ $t("review-and-continue") }}</h2>
              <table style="margin: 0 auto; font-size: 1.2em !important" id="needsTable">
                <tr>
                  <th>{{ $t("weeks-in-schedule") }}</th>
                  <th v-if="weeksNeeded > 0">{{ $t("additional-weeks-needed") }}</th>
                  <th>{{ division.is_across ? $t("across-division-sizes") : $t("team-in-division") }}</th>
                  <th>
                    {{ $t("itemstring-plural-per-team", [itemString.plural]) }}
                    <span v-if="division.is_across"> {{ $t("smallest-div") }}</span>
                  </th>
                  <th>{{ $t("total-itemstring-plural", [itemString.plural]) }}</th>
                  <th>{{ $t("timeslots-available") }}</th>
                  <th>{{ $t("additional-needed") }}</th>
                </tr>
                <tr>
                  <!-- Weeks -->
                  <td>{{ seasonDates.weeks }}</td>
                  <!-- Additional weeks if weekend method> -->
                  <td v-if="weeksNeeded > 0" style="background: #fafbed">{{ weeksNeeded }}</td>
                  <!-- Sizes teams -->
                  <td>{{ division.is_across ? `${a1.teams.length + " - " + a2.teams.length}` : teamCount || "--" }}</td>
                  <!-- Games per team -->
                  <td>{{ itemsPerTeam }}</td>
                  <!-- Total games -->
                  <td>{{ slotsNeeded || "--" }}</td>
                  <!-- Slots available -->
                  <td style="background: #eefdec">{{ slotsAvailable(sconfig.division_id) }}</td>
                  <!-- Needed -->
                  <td style="background: #fafbed">{{ additionalNeeded }}</td>
                </tr>
              </table>

              <br />
              <div v-if="additionalNeeded > 0" style="font-size: 1.2em">
                {{
                  $t("youll-need-to-create-additionalneeded-additional-timeslots-to-fulfill-this-schedules-needs", [
                    additionalNeeded,
                  ])
                }}
              </div>
              <div v-else style="color: green; font-size: 1.2em;">
                {{ $t("you-have-enough-timeslots-to-successfully-schedule") }}
              </div>
            </div>
            <div v-if="!sconfig.division_id">{{ $t("please-select-a-division-to-continue") }}</div>
            <div v-else-if="!sconfig.endDate">{{ $t("please-select-schedule-dates-to-continue") }}</div>
            <div v-else-if="this.weeksNeeded > 0">
              {{ $t("please-select-enough-schedule-weeks-to-continue-with-the-weekend-method") }}
            </div>
            <div v-else-if="!sconfig.count">
              {{ $t("please-adjust-number-of-itemstring-plural-to-be-more-than", [itemString.plural]) }}
            </div>
            <Button
              style="margin: 15px auto; font-size: 1.5em; height: 79; width: auto; padding: 10px 25px"
              class="p-button-lg dsButton"
              :disabled="!configValid"
              @click="nextSchedule"
            >
              {{ $t("Button.continue") }}
            </Button>
          </div>
          <div class="p-col-12">
            <Button class="p-button-text" @click="cancelSchedule"> {{ $t("Button.cancel") }} </Button>
          </div>
          <div v-if="!isProduction">
            {{ sconfig }}
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog
      :header="$t('edit-schedule-configuration')"
      :visible.sync="configAdditionalDialog"
      :modal="true"
      :style="{ minWidth: '75%', minHeight: '25vh', maxWidth: '95%' }"
      :show-header="false"
      :closeOnEscape="false"
    >
      <div class="p-mt-3" style="height: 100%; width: 100%; min-height: 50vh">
        <div class="p-my-5" style="height: 5vh">
          <div class="progress-container p-justify-center">
            <ul class="progress-steps">
              <li v-bind:class="{ 'active ': configAdditionalDialog === true }">1</li>
              <li>2</li>
            </ul>
          </div>
        </div>
        <div class="p-grid">
          <div class="p-col-12">
            <div class="p-grid p-justify-center">
              <div class="p-col-12">
                <div class="title is-3 p-my-3">
                  <span v-if="additionalNeeded" style="color: darkred;">
                    {{ $t("additionalneeded-more-timeslots-needed", [additionalNeeded]) }}
                  </span>
                  <span v-else style="font-size: 1.2em; color: green; font-weight: bold">
                    <font-awesome-icon
                      class="cursorpointer menuIcon"
                      style="color: green;"
                      :icon="['fal', 'check-circle']"
                    />&nbsp;
                    <span></span>
                  </span>
                </div>
              </div>
              <div class="p-col-6">
                <div class="config-box">
                  <h4 class="title is-4 p-my-3">
                    <div v-if="additionalNeeded > 0" style="font-size: 1.2em">
                      {{
                        $t(
                          "youll-need-to-create-additionalneeded-additional-timeslots-to-fulfill-this-schedules-needs",
                          [additionalNeeded],
                        )
                      }}
                    </div>
                    <div v-else style="font-size: 1.2em; ">
                      {{ $t("you-have-enough-timeslots-to-start-scheduling") }}
                    </div>
                  </h4>
                </div>
              </div>
              <div class="p-col-12">
                <div class="config-box">
                  <Button
                    class="p-button-lg p-mb-2"
                    style="margin: 15px auto; font-size: 1.5em; height: 79; width: auto; padding: 10px 25px"
                    v-bind:class="{ 'p-button-lg dsButton': additionalNeeded > 0 }"
                    :disabled="!configValid"
                    @click="toggleAdditionalConfigDialog(false)"
                  >
                    {{ $t("num-timeslots", [timeslotButton]) }}
                  </Button>

                  <div>
                    <Button class="p-button-sm p-button-text" @click="toggleConfigDialog(true)">
                      {{ $t("edit-settings") }}
                    </Button>
                  </div>
                </div>
              </div>
              <div class="p-col-12">
                <Button class="p-button-text" @click="cancelSchedule"> {{ $t("Button.cancel") }} </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog
      :header="$t('edit-schedule-configuration')"
      :visible.sync="venueBalanceDialog"
      :modal="true"
      :style="{ width: 'auto', maxWidth: '30vw' }"
      :show-header="false"
      :closeOnEscape="false"
    >
      <div class="p-mt-3" style="height: 100%; width: 100%; min-height: 50vh">
        <div class="p-grid">
          <div class="p-col-12">
            <div class="p-grid p-justify-center">
              <div class="p-col-12">
                <div class="config-box">
                  <h1 class="title is-2 p-my-3">
                    {{ $t("venue-configuration") }}
                  </h1>
                  <div class="p-my-2" style="font-size: 1.5em; line-height: 2em">
                    <font-awesome-icon
                      class="cursorpointer menuIcon dsColor"
                      @click="showVenueBalanceWindowInfo = true"
                      :icon="['fal', 'info-circle']"
                    />&nbsp;
                    <span></span>
                  </div>
                </div>
              </div>
              <div class="p-my-2 venueConfigurationContent">
                <div class="p-field-radiobutton">
                  <b-radio v-model="sconfig.venue_balance_method" native-value="0">{{
                    $t("use-best-venues-first")
                  }}</b-radio>
                  <br />
                  <b-radio v-model="sconfig.venue_balance_method" native-value="1">{{
                    $t("evenly-distribute-venues")
                  }}</b-radio>
                  <div class="p-ml-6 p-field-radiobutton">
                    <b-radio :disabled="!isSelectedEvenly" v-model="sconfig.venue_balance_tolerance" native-value="0">{{
                      $t("low")
                    }}</b-radio
                    ><br />
                    <b-radio :disabled="!isSelectedEvenly" v-model="sconfig.venue_balance_tolerance" native-value="1">{{
                      $t("medium")
                    }}</b-radio
                    ><br />
                    <b-radio :disabled="!isSelectedEvenly" v-model="sconfig.venue_balance_tolerance" native-value="2">{{
                      $t("high")
                    }}</b-radio>
                  </div>
                </div>
              </div>
              <div class="p-col-12">
                <div class="config-box">
                  <Button
                    style="margin: 15px auto; font-size: 1.5em; height: 20; width: auto; padding: 10px 25px"
                    class="p-button-lg dsButton"
                    @click="toggleVenueBalanceDialog(false)"
                  >
                    {{ $t("Button.save") }} </Button
                  ><br />
                  <Button class="p-button-text" @click="toggleVenueBalanceDialog(false)">
                    {{ $t("Button.cancel") }}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog
      :header="$t('edit-schedule-configuration')"
      :visible.sync="showVenueBalanceWindowInfo"
      :modal="true"
      :style="{ width: 'auto', maxWidth: '30vw' }"
      :show-header="false"
      :closeOnEscape="false"
    >
      <div class="p-mt-3" style="height: 100%; width: 100%; min-height: 50vh">
        <div class="p-grid">
          <div class="p-col-12">
            <div class="p-grid p-justify-left">
              <div class="p-col-12">
                <div class="title is-3 p-my-3">
                  <span style="font-size: 1.2em; font-weight: bold">
                    <font-awesome-icon class="cursorpointer menuIcon dsColor" :icon="['fal', 'info-circle']" />&nbsp;
                    <span></span>
                  </span>
                </div>
                <div class="config-box p-text-left">
                  <h3 class="title is-5 p-my-3">
                    {{ $t("use-best-first") }}
                  </h3>
                  <p>
                    {{ $t("attempts-to-use-timeslots-in-venues-with-higher-priorities") }}
                  </p>
                  <br />
                  Example:
                  <table id="balanceExampleTable">
                    <tr>
                      <th>Team&nbsp;</th>
                      <th>Venue X (+3)</th>
                      <th>Venue Y (0)</th>
                      <th>Venue Z (-3)</th>
                    </tr>
                    <tr style="height: 2em; text-align: right;">
                      <th style="text-align: center;">Team 1B&nbsp;</th>
                      <td>11</td>
                      <td>4</td>
                      <td>0</td>
                    </tr>
                    <tr style="height: 2em; text-align: right;">
                      <th style="text-align: center;">Team 2B&nbsp;</th>
                      <td>10</td>
                      <td>5</td>
                      <td>0</td>
                    </tr>
                    <tr style="height: 2em; text-align: right;">
                      <th style="text-align: center;">Team 3B</th>
                      <td>11</td>
                      <td>4</td>
                      <td>0</td>
                    </tr>
                    <tr style="height: 2em; text-align: right;">
                      <th style="text-align: center;">Team 4B</th>
                      <td>10</td>
                      <td>5</td>
                      <td>0</td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="p-col-12">
                <div class="config-box p-text-left">
                  <h3 class="title is-5 p-my-3">
                    {{ $t("evenly-distribute") }}
                  </h3>
                  <p>
                    {{ $t("ignores-priority-score-and-attempts-to-even-out-the-distribution-of-venues-across-teams") }}
                  </p>
                  <br />
                  Example:
                  <table id="balanceExampleTable">
                    <tr>
                      <th>Team&nbsp;</th>
                      <th>Venue X (+3)</th>
                      <th>Venue Y (0)</th>
                      <th>Venue Z (-3)</th>
                    </tr>
                    <tr style="height: 2em; text-align: right;">
                      <th style="text-align: center;">Team 1B&nbsp;</th>
                      <td>5</td>
                      <td>5</td>
                      <td>5</td>
                    </tr>
                    <tr style="height: 2em; text-align: right;">
                      <th style="text-align: center;">Team 2B&nbsp;</th>
                      <td>5</td>
                      <td>5</td>
                      <td>5</td>
                    </tr>
                    <tr style="height: 2em; text-align: right;">
                      <th style="text-align: center;">Team 3B</th>
                      <td>5</td>
                      <td>5</td>
                      <td>5</td>
                    </tr>
                    <tr style="height: 2em; text-align: right;">
                      <th style="text-align: center;">Team 4B</th>
                      <td>5</td>
                      <td>5</td>
                      <td>5</td>
                    </tr>
                  </table>
                </div>
              </div>
              <div class="p-col-12">
                <div class="config-box">
                  <Button class="p-button-text" @click="showVenueBalanceWindowInfo = false">
                    {{ $t("Button.close") }}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>

    <Dialog
      :header="$t('edit-schedule-configuration')"
      :visible.sync="scheduleDialog"
      :modal="true"
      :style="{ width: 'auto', maxWidth: '75vw' }"
      :show-header="false"
      :closeOnEscape="false"
    >
      <div v-if="scheduleBusy" style="padding: 30px">
        <h1 class="title is-1">{{ $t("scheduling-in-progress") }}</h1>
        <p class="subheader">{{ $t("now-might-be-a-good-time-for-a-water-break") }}</p>
        <br /><br />
        <img class="centeredGif" :src="`${baseURL}/diamond.gif`" />
      </div>
      <div v-else class="p-mt-5" style="">
        <div class="p-my-5" style="height: 5vh">
          <div class="progress-container p-justify-center">
            <ul class="progress-steps">
              <li v-bind:class="{ 'active ': scheduleDialog === true }">1</li>
              <li v-bind:class="{ 'active ': scheduleDialog === true }">2</li>
            </ul>
          </div>
        </div>
        <h1 class="title is-2 p-my-3">{{ $t("submit-schedule") }}</h1>
        <div class="p-grid">
          <div class="p-col-12">
            {{ $t("enter-your-scheduling-constraints-and-then-click-submit-to-schedule") }}
          </div>
          <div class="p-col-12 p-mb-3 p-mt-1 constraintBox">
            <label class="p-mb-1"> {{ $t("schedule-name") }} </label>
            <br />
            <InputText
              id="scheduleName"
              :placeholder="$t('enter-name')"
              autofocus
              v-model="sconfig.title"
              type="text"
            />
          </div>
          <div class="p-col-3 p-my-3">
            <div style="max-width: 420px; margin: 0 auto; text-align: center">
              <div class="p-field-checkbox">
                <Checkbox v-model="sconfig.use_coach_conflict_method" :binary="true" />&nbsp;
                <label style="font-size: 1.4em"> {{ $t("avoid-double-booking-coaches") }} </label>
              </div>
            </div>
          </div>

          <div class="p-col-3 p-my-3">
            <div
              style="max-width: 420px; margin: 0 auto; text-align: center"
              v-tooltip="'Only allow the home teams assigned to a venue be scheduled as home'"
            >
              <div class="p-field-checkbox">
                <Checkbox v-model="sconfig.enforce_home" :binary="true" />&nbsp;
                <label style="font-size: 1.4em"> {{ $t("enforce-home-team-venues") }} </label>
              </div>
            </div>
          </div>
          <div class="p-col-3 p-my-3">
            <div style="max-width: 420px; margin: 0 auto; text-align: center">
              <div class="p-field-checkbox">
                <Checkbox v-model="sconfig.do_balance" :binary="true" />&nbsp;
                <label style="font-size: 1.4em"> {{ $t("balance-days-times-venues") }} </label>
              </div>
              <small> {{ $t("may-result-in-more-unscheduled-games") }} </small>
            </div>
          </div>
          <div class="p-col-3 p-my-3">
            <div style="max-width: 420px; margin: 0 auto; text-align: center">
              <div class="p-field-checkbox">
                <Checkbox v-model="sconfig.balance_venues" :binary="true" @change="showVenueBalanceWindow" />&nbsp;
                <label
                  for="horizontal"
                  v-tooltip="'Based on venue priority on the Venue pages'"
                  style="font-size: 1.4em"
                  >{{ $t("use-venue-priority-balancing") }}
                  <font-awesome-icon
                    class="cursorpointer menuIcon"
                    v-show="sconfig.balance_venues"
                    @click="showVenueBalanceWindow"
                    :icon="['fal', 'cog']"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="p-col-3">
            <div class="p-mt-3 constraintBox">
              <label for="horizontal">{{ $t("max-games-day") }}</label>
              <br />
              <a @click="sconfig.max_games_day = 1" v-show="sconfig.max_games_day === 0">
                {{ $t("Button.add-constraint") }}
              </a>
              <InputNumber
                v-show="sconfig.max_games_day > 0"
                class="configNumber p-mt-1 p-input-secondary"
                v-model="sconfig.max_games_day"
                showButtons
                buttonLayout="horizontal"
                :step="1"
                :min="0"
                :max="10"
                @input="configUpdate"
                incrementButtonIcon="pi pi-plus"
                decrementButtonIcon="pi pi-minus"
              />
            </div>
          </div>
          <div class="p-col-3">
            <div class="p-mt-3 constraintBox">
              <label for="horizontal">{{ $t("max-games-per-week") }}</label>
              <br />
              <a
                @click="sconfig.max_games_week = Math.max(1, sconfig.max_games_day)"
                v-show="sconfig.max_games_week === 0"
              >
                {{ $t("Button.add-constraint") }}
              </a>
              <InputNumber
                v-show="sconfig.max_games_week > 0"
                class="configNumber p-mt-1"
                v-model="sconfig.max_games_week"
                showButtons
                buttonLayout="horizontal"
                :step="1"
                :min="0"
                :max="70"
                @input="configUpdate"
                incrementButtonIcon="pi pi-plus"
                decrementButtonIcon="pi pi-minus"
              />
            </div>
          </div>
          <div class="p-col-3">
            <div class="p-mt-3 constraintBox">
              <label
                for="horizontal"
                v-tooltip="
                  'How many minutes should pass before a team can play again on the same day? Enter 0 to allow for back to back games.'
                "
                >{{ $t("minutes-between-games") }}</label
              >
              <br />
              <a
                v-if="sconfig.max_games_day !== 1 && sconfig.max_games_day !== 1"
                @click="sconfig.min_minutes_rest = 60"
                v-show="sconfig.min_minutes_rest === 0"
              >
                {{ $t("Button.add-constraint") }}
              </a>
              <i v-else> {{ $t("not-available") }} </i>
              <InputNumber
                v-show="sconfig.min_minutes_rest > 0 && sconfig.max_games_day > 1"
                :disabled="sconfig.next_game_offset !== 0 || sconfig.max_games_day <= 1"
                class="configNumber p-mt-1"
                v-model="sconfig.min_minutes_rest"
                showButtons
                buttonLayout="horizontal"
                :step="15"
                :min="0"
                :max="1440"
                @input="configUpdate"
                incrementButtonIcon="pi pi-plus"
                decrementButtonIcon="pi pi-minus"
              />
            </div>
          </div>
          <div class="p-col-3">
            <div class="p-mt-3 constraintBox">
              <label
                for="horizontal"
                v-tooltip="
                  'How many nights should pass before a team can play again? Enter 1 to allow for consecutive days, 2 for one full day off, etc.'
                "
                >{{ $t("nights-between-games") }}</label
              >
              <br />
              <a
                v-if="sconfig.max_games_week !== 1 && sconfig.max_games_day < 2"
                v-show="sconfig.next_game_offset === 0"
                @click="sconfig.next_game_offset = 1"
              >
                {{ $t("Button.add-constraint") }}
              </a>

              <i v-else> {{ $t("not-available") }}</i>
              <InputNumber
                v-show="sconfig.next_game_offset > 0 && sconfig.max_games_day < 2"
                class="configNumber p-mt-1"
                :disabled="sconfig.max_games_day !== 1"
                v-model="sconfig.next_game_offset"
                showButtons
                buttonLayout="horizontal"
                :step="1"
                :min="0"
                :max="30"
                @input="configUpdate"
                incrementButtonIcon="pi pi-plus"
                decrementButtonIcon="pi pi-minus"
              />
            </div>
          </div>
          <div class="p-col-12">
            <Button
              style="margin: 15px auto; font-size: 1.5em; height: 79; width: auto; padding: 10px 25px"
              class="p-button-lg dsButton"
              :disabled="!sconfig.title"
              @click="submitSchedule"
            >
              SUBMIT
            </Button>
            <br /><br />
            <Button class="p-button-text p-button-lg" @click="toggleScheduleDialog(false)">
              {{ $t("Button.cancel") }}
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: [
    "configDialog",
    "configAdditionalDialog",
    "toggleAdditionalConfigDialog",
    "toggleConfigDialog",
    "venueBalanceDialog",
    "showVenueBalanceWindowInfo",
    "toggleVenueBalanceDialog",
    "showVenueBalanceWindow",
    "sconfig",
    "windowWidth",
    "setStartDate",
    "setEndDate",
    "weeksNeeded",
    "division",
    "seasonDates",
    "teamCount",
    "a1",
    "a2",
    "itemsPerTeam",
    "slotsNeeded",
    "slotsAvailable",
    "additionalNeeded",
    "configValid",
    "nextSchedule",
    "cancelSchedule",
    "scheduleDialog",
    "scheduleBusy",
    "submitSchedule",
    "toggleScheduleDialog",
    "oldDates",
  ],
  data() {
    return {
      scheduleTypes: [
        { name: this.$t("games"), value: 0 },
        { name: this.$t("practice"), value: 1 },
      ],
      practiceTypes: [
        { name: this.$t("practices-per-team-per-week"), value: 1 },
        { name: this.$t("practices-per-team-total"), value: 2 },
      ],
      gameTypes: [
        { name: this.$t("rounds-per-team"), value: 0 },
        { name: this.$t("games-per-team-per-week"), value: 1 },
        { name: this.$t("games-per-team-total"), value: 2 },
      ],
    };
  },
  methods: {
    configUpdate() {
      let c = this.sconfig;

      if (c.max_games_day > 0 && c.max_games_week > 0 && c.max_games_day > c.max_games_week) {
        console.log("DoMaxGamesDay");
        c.max_games_week = c.max_games_day;
      }

      if (c.max_games_week > 0 && c.max_games_day > c.max_games_week) {
        console.log("DoMaxGamesDay");
        c.max_games_day = c.max_games_week;
      }

      if (c.max_games_day === 1) {
        console.log("DoMinsRest");
        c.min_minutes_rest = 0;
      }

      if (c.max_games_day > 1) {
        console.log("DoMinsRest");
        c.next_game_offset = 0;
      }
    },
  },
  computed: {
    itemString() {
      let x = {
        singluar: this.$t("item_string.practice"),
        plural: this.$t("item_string.practices"),
      };
      if (this.sconfig.mode === 0) {
        x.singular = this.$t("item_string.game");
        x.plural = this.$t("item_string.games");
      }
      return x;
    },
    timeslotButton() {
      if (this.additionalNeeded > 0) {
        return this.$t("Button.create");
      } else {
        return this.$t("Button.review");
      }
    },
    isSelectedEvenly() {
      return this.sconfig.venue_balance_method === 1;
    },
  },
};
</script>
